import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import MoneyView from 'shared/components/MoneyView';
import { actions } from 'shared/actions/app';
import { Money } from 'shared/types/common';
import { Idea } from '../../../../types';
import { Notification } from '../IpoNotification';

import './index.scss';

//@translate(context:onAccount)
type AccountName = 'USD' | 'RUB';

const b = b_.with('idea-landing-deposit');

interface Props {
  balance: Money;
  idea: Idea;
}

export const Deposit: React.FC<Props> = ({ balance, idea: { enterAmount, category } }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const showDepositModal = () =>
    dispatch(
      actions.showDepositModal({
        value: enterAmount.value - balance.value,
        currency: enterAmount.currency,
      })
    );

  const accountName = t(enterAmount.currency as AccountName, { context: 'onAccount' });

  return (
    <div className={b()}>
      <button className={b('btn')} onClick={showDepositModal} data-testid="deposit-btn">
        {t('To deposit')}
      </button>
      <span className={b('comment')} data-testid="deposit-tally">
        {t('On main {{accountName}} account', { accountName })} <MoneyView>{balance}</MoneyView>.
        <br />
        {category === 'IPO' && <Notification notEnoughMoney />}
      </span>
    </div>
  );
};
